<template>
  <v-content class="content_body">
    <v-flex xs12>
      <v-layout row wrap>
        <v-flex xs12>
          <label class="font-weight-black caption"
            >Escolha o tipo de segurado</label
          >
        </v-flex>
        <v-btn 
          :id="text.replace(/ /g, '-')"
          class="jns-button blue-button flex mb-4" 
          v-for="(text, index) in ['Pessoa Jurídica', 'Pessoa Física']"
          :key="index"
          :class="{ active: insured.stepType == index + 1 }"
          :value="index + 1"
          @click="selectInsuredType($event)"
        >
          {{ text }}
          <v-icon v-if="insured.stepType == index + 1" class
            >check_circle_alt</v-icon
          >
        </v-btn>
        <v-flex xs12 v-if="insured.stepType <= 2">
          <v-layout row wrap>
            <v-flex>
              <v-text-field
                :placeholder="'Pesquisar'"
                :label="textBoxlabel"
                :rules="[rules.obrigatorio, rules.cpfCnpjInvalido]"
                @click:append="getInsure"
                @input="unselectInsured"
                v-model="insured.cnpj"
                v-mask="textBoxMask"
                @keypress="inputActive()"
                @blur="inputActive()"
                @focus="focus()"
                @keyup.enter="getInsure()"
                class="jns-input"
                id="emissao_segurado_input_search"
              >
              <template v-slot:append>
              <v-icon class="mt-1 mr-1 input_search" id="search_segurado"  @click="getInsure()">search</v-icon>
              </template>
            </v-text-field>
            </v-flex>

            <div class="msg_cpf_segurado" v-if="showMsgCpf">
              <p>
                Conforme Art. 2º do Ato Conjunto n°1 de 16 de Outubro de 2019, o
                Segurado das apólices de Seguro Garantia de Depósito Recursal
                deve ser o reclamante ou o exequente e não mais a Vara ou
                Tribunal.
              </p>
            </div>
          </v-layout>
        </v-flex>

        <v-flex xs12 v-if="insured.stepType <= 2 && insured.info">
          <person-info-box
            :info="insured.info"
            :showAddressChangeButton="true"
            :lograduroCompacto="false"
            @salvarEndereco="salvarEndereco"
          ></person-info-box>
        </v-flex>

        <!-- PASSO 2 - STEP TYPE 2 -->
        <div class="flex xs12" v-if="['3', '4'].includes(insured.stepType)">
          <v-layout
            row
            wrap
            v-if="
              (['3', '4'].includes(insured.stepType) &&
                !insured.hasOwnProperty('notFound')) ||
                (['3'].includes(insured.stepType) &&
                  lastInsuredSearchWasCNPJ) ||
                (['3', '4'].includes(insured.stepType) &&
                  insuredResults.length &&
                  showListToSelectInsured)
            "
          >
            <v-flex xs6>
              <v-text-field
                class="jns-input"
                :label="
                  insured.stepType == 2
                    ? 'Digite o CNPJ ou a Razão Social'
                    : 'Digite a Razão Social'
                "
                placeholder="Pesquisar"
                v-model="insured.name"
                :key="insured.stepType"
                append-icon="search"
                @click:append="getInsuredByRazaoSocial()"
                @keyup.enter="getInsuredByRazaoSocial()"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <proposta-form
            v-if="['3', '4'].includes(insured.stepType) && insured.notFound"
            :person="insured"
            :type="'insured'"
            :lograduroCompacto="false"
            @click:append="getInsuredByRazaoSocial()"
            @keyup.enter="getInsuredByRazaoSocial()"
            v-on:updatePerson="updateInsured"
            v-on:formValid="updateInsuredFormValid"
          ></proposta-form>
        </div>
      </v-layout>
    </v-flex>
  </v-content>
</template>

<script lang="js">
import ViewMixin from "@/mixins/ViewMixin";
import { isValidCnpj, isValidCpf } from "@/libs/utils";

export default {
  name: "SeguradoPasso2",
  mixins: [ViewMixin],
  data: () => ({
    showMsgCpf: false,
    rules: {
      obrigatorio: (value) => !!value || "Campo obrigatório.",
      cpfCnpjInvalido: (v) =>
        !!v && v.length > 14
          ? (!!v && isValidCnpj(v)) || "Número de documento inválido"
          : (!!v && isValidCpf(v)) || "Número de documento inválido",
    },
  }),
  props: [
    "taker",
    "step",
    "unselectInsured",
    "insured",
    "lastInsuredSearchWasCNPJ",
    "insuredResults",
    "showListToSelectInsured",
    "updateInsured",
    "updateInsuredFormValid",
    "selectInsured",
    "insuredFormValid",
  ],
  computed: {
    textBoxlabel() {
      if (this.insured) {
        switch (this.insured.stepType) {
          case "1":
            return "Digite o CNPJ do segurado";
          case "2":
            return "Digite o CPF do segurado";
        }
      } else return "Digite o CNPJ do segurado";
    },
    textBoxMask() {
      if (this.insured) {
        switch (this.insured.stepType.toString()) {
          case "1":
            return "##.###.###/####-##";
          case "2":
            return "###.###.###-##";
          default:
            "##.###.###/####-##";
        }
      } else return "##.###.###/####-##";
    },
  },
  methods: {
    selectInsuredType(event) {
      if (parseInt(event.currentTarget.value) <= 2) {
        if (parseInt(event.currentTarget.value) == 2) {
          this.showMsgCpf = true;
        } else {
          this.showMsgCpf = false;
        }
        this.$forceUpdate();
        this.$emit("selectInsuredType", event);
      }
    },
    getInsure() {
      this.showMsgCpf = false;
      if (this.insured.stepType == 1 && isValidCnpj(this.insured.cnpj))
        this.$emit("getInsuredByCNPJ");
      if (this.insured.stepType == 2 && isValidCpf(this.insured.cnpj))
        this.$emit("getInsuredByCPF");
    },
    getInsuredByCNPJ() {
      this.$emit("getInsuredByCNPJ");
    },
    getInsuredByRazaoSocial() {
      this.$emit("getInsuredByRazaoSocial");
    },
    focus() {
      this.showMsgCpf = false;
    },
    inputActive() {
      if (this.insured) {
        if (this.insured.cnpj != null) {
          if (this.insured.cnpj.length > 0) {
            this.showMsgCpf = false;
          }
        }
      }
    },

    async salvarEndereco(endereco){
      let data;

      let payload = {
        document: this.insured.cnpj.replace(/[^\w\s]/gi, ""),
        id: this.insured.info.id,
        data: {
          tipo_pessoa: this.insured.info.tipo_pessoa,
          nome: this.insured.info.nome,
          endereco: endereco
        }
      };

        try {
          this.showLoadingIndicator();
          data = await this.$store.dispatch("UPDATE_INSURED_ADDRESS", payload);
        } catch (e) {
          if (e && e[0] && !e[0].ativo) {
            return this.handleInactivePersonError(e[0], "Segurado");
          }
          this.defaultHandlerError(e);
          return;
        } finally {
          this.modalNome = false;
          this.hideLoadingIndicator();
        }

        this.alertText = this.handleAlertText2(
          "Endereço atualizado com sucesso!"
        );

        this.$emit("updateInsuredInfo", {...data, nome: data.nome.toUpperCase()});

        this.stepCompleted = 2;
        this.modalNome = false;
        await this.$nextTick();
        this.$forceUpdate();
      }
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>
<style lang="scss">
#jns {
  .content_body {
    padding: 20px 40px 77px 40px;
    background-color: white;
  }

  .msg_cpf_segurado {
    width: 30%;
    background-color: #ccc;
    position: absolute;
    z-index: 999;
    box-shadow: 0 0 1em #ccc;
    padding: 12px;
    left: 12px;
    top: 207px;
    border-radius: 0.4em;

    p {
      text-align: left;
      margin-bottom: 0;
      font-weight: normal;
    }
  }

  .msg_cpf_segurado:after {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-bottom-color: #ccc;
    border-top: 0;
    margin-left: -10px;
    margin-top: -10px;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/router/views/Propostas/Passos/Segurado.vue